export default {
  init() {
        /* global currentLanguage */
    // JavaScript to be fired on all pages
    var hamburger = document.querySelector(".hamburger");
    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
    });
    jQuery(document).ready(function () {
      jQuery("#user_login").attr("placeholder", "Användarnamn");
      jQuery("#user_pass").attr("placeholder", "Lösenord");
    });

    if (typeof window.CookieConsent !== "undefined") {
      window.CookieConsent.init({
        // More link URL on bar.
        modalMainTextMoreLink: null,
        // How long to wait until bar comes up.
        barTimeout: 500,
        // Look and feel.
        theme: {
          barColor: "#333",
          barTextColor: "#fff",
          barMainButtonColor: "#fff",
          barMainButtonTextColor: "#333",
          modalMainButtonColor: "#323d37",
          modalMainButtonTextColor: "#fff",
        },
        language: {
          current: currentLanguage,
          locale: {
            sv: {
              barMainText:
                "Denna webbplats använder cookies för att säkerställa att du får den bästa upplevelsen på vår webbplats.",
              closeAriaLabel: "stäng",
              barLinkSetting: "Cookie-inställningar",
              barBtnAcceptAll: "Acceptera alla cookies",
              modalMainTitle: "Cookie-inställningar",
              modalMainText:
                "Cookies är små datastycken som skickas från en webbplats och lagras på användarens dator av användarens webbläsare medan användaren surfar. Din webbläsare lagrar varje meddelande i en liten fil, kallad cookie. När du begär en annan sida från servern skickar din webbläsare tillbaka cookien till servern. Cookies designades för att vara en pålitlig mekanism för webbplatser att komma ihåg information eller att registrera användarens surfaktivitet.",
              modalBtnSave: "Spara aktuella inställningar",
              modalBtnAcceptAll: "Acceptera alla cookies och stäng",
              modalAffectedSolutions: "Påverkade lösningar:",
              learnMore: "Läs mer",
              on: "På",
              off: "Av",
              enabled: "är aktiverad.",
              disabled: "är inaktiverad.",
              checked: "markerad",
              unchecked: "omarkerad",
            },
            en: {
              barMainText:
                "This website uses cookies to ensure you get the best experience on our website.",
              closeAriaLabel: "close",
              barLinkSetting: "Cookie settings",
              barBtnAcceptAll: "Accept all cookies",
              modalMainTitle: "Cookie settings",
              modalMainText:
                "Cookies are small pieces of data sent from a website and stored on the user's computer by a web browser while the user is browsing the web. Your browser stores each piece of data in a small file called a cookie. When you request another page from the server, your web browser sends the cookie back to the server. Cookies were designed to be a reliable mechanism for websites to remember information or to record the user's browsing activity.",
              modalBtnSave: "Save current settings",
              modalBtnAcceptAll: "Accept all cookies and close",
              modalAffectedSolutions: "Affected services:",
              learnMore: "Learn more",
              on: "On",
              off: "Off",
              enabled: "is enabled.",
              disabled: "is disabled.",
              checked: "checked",
              unchecked: "unchecked",
            },
            ar: {
              barMainText:
              "إن موقع الإنترنت هذا يستخدم ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة في موقعنا على الويب.",
              closeAriaLabel: "اغلق",
              barLinkSetting: "إعدادات ملفات تعريف الارتباط",
              barBtnAcceptAll: "وافق على جميع ملفات تعريف الارتباط",
              modalMainTitle: "إعدادات ملفات تعريف الارتباط",
              modalMainText:
              "ملفات تعريف الارتباط (كوكيز) هي ملفات نصية تحتوي على كميات صغيرة من المعلومات التي يتم إرسالها من موقع الويب ويتم تخزينها على جهاز الكمبيوتر من قبل متصفح المستخدم عندما  يقوم هذا بالتصفح. يقوم المتصفح الخاص بك بتخزين كل إشعار في ملف صغير، يسمى ملف تعريف الارتباط (كوكي). عندما تطلب صفحة أخرى من الخادم يرسل متصفح الويب الخاص بك الكوكي إلى الخادم. يتم تصميم ملفات تعريف الارتباط (كوكيز) لتكون آلية موثوقة لكي تتذكر مواقع الويب  المعلومات أو لتسجيل نشاط التصفح الخاص بالمستخدم.",
              modalBtnSave: "حفظ الإعدادات الحالية",
              modalBtnAcceptAll: "وافق على جميع ملفات تعريف الارتباط وأغلق.",
              modalAffectedSolutions: "حلول متأثرة",
              learnMore: "تعرف على المزيد",
              on: "تشغيل",
              off: "ايقاف",
              enabled: "مُمكّن.",
              disabled: "مُعطل.",
              checked: "مُحدّد",
              unchecked: "غير مُحدّد",
            },
            fi: {
              barMainText:
              "Käytämme tällä sivustolla evästeitä varmistaaksemme, että kokemuksesi sivustostamme on paras mahdollinen.",
              closeAriaLabel: "sulje",
              barLinkSetting: "Evästeasetukset",
              barBtnAcceptAll: "Hyväksy kaikki evästeet",
              modalMainTitle: "Evästeasetukset",
              modalMainText:
              "Evästeet (cookie) ovat pieniä tekstitiedostoja, joita lähetetään käyttäjän tietokoneeseen hänen surffatessaan verkossa, ja jotka tallentuvat tietokoneen selaimeen. Selain tallentaa jokaisen viestin pieneksi tiedostoksi, jota kutsutaan evästeeksi. Käyttäjän siirtyessä toiselle sivulle selain lähettää evästeen takaisin palvelimeen. Evästeiden tarkoituksena on toimia luotettavana mekanismina, jonka avulla verkkosivustot tallentavat tietoja tai rekisteröivät käyttäjän surffausaktiviteetteja.",
              modalBtnSave: "Tallenna tämänhetkiset asetukset",
              modalBtnAcceptAll: "Hyväksy kaikki evästeet ja sulje",
              modalAffectedSolutions: "Ratkaisuja, joihin ne vaikuttavat:",
              learnMore: "Lisätietoja",
              on: "Päällä",
              off: "Pois päältä",
              enabled: "on käytössä.",
              disabled: "on poissa käytöstä.",
              checked: "valittu",
              unchecked: "valitsematon",
            },
            fa: {
              barMainText:
              "این وبگاه از کوکی استفاده می",
              closeAriaLabel: "بستن",
              barLinkSetting: "تنظیمات کوکی",
              barBtnAcceptAll: "پذیرفتن همه کوکی",
              modalMainTitle: "تنظیمات کوکی",
              modalMainText: "کوکی",
              modalBtnSave: "حفظ کردن تنظیمات کنونی",
              modalBtnAcceptAll: "همه کوکی",
              modalAffectedSolutions: "راهکارهایی که تحت تأثیر قرار می.",
              learnMore: "بیشتر بدانید",
              on: "فعال",
              off: "غیرفعال",
              enabled: "فعال است.",
              disabled: "غیرفعال است.",
              checked: "تیک‌خورده",
              unchecked: "تیک نخورده",
            },
            ro: {
              barMainText:
              "Acest site web folosește cookie-uri pentru a vă asigura că aveți cea mai bună experiență pe site-ul nostru.",
              closeAriaLabel: "închide",
              barLinkSetting: "Setări cookie",
              barBtnAcceptAll: "Acceptați toate cookie-urile",
              modalMainTitle: "Setări cookie",
              modalMainText:
              "Cookie-urile sunt mici fragmente de date care sunt trimise de pe un site web și stocate pe computerul utilizatorului de către browserul utilizatorului în timp ce acesta navighează pe internet. Browserul dvs. stochează fiecare mesaj într-un fișier mic, numit cookie. Când solicitați o altă pagină de pe server, browserul dvs. trimite cookie-ul înapoi serverului. Cookie-urile au fost concepute pentru a fi un mecanism de încredere pentru ca site-urile web să rețină informații sau să înregistreze activitatea de navigare a utilizatorului.",
              modalBtnSave: "Salvați setările curente",
              modalBtnAcceptAll: "Acceptați toate cookie-urile și închideți",
              modalAffectedSolutions: "Solutii afectate:",
              learnMore: "Aflați mai multe",
              on: "Pornire",
              off: "Oprire",
              enabled: "este activată.",
              disabled: "este dezactivată.",
              checked: "selectat",
              unchecked: "neselectat",
            },
            so: {
              barMainText:
              "Boggaan wuxuu isticmaalayaa cookies si aad sida ugu fiican ula falgashid boggeena.",
              closeAriaLabel: "xidh",
              barLinkSetting: "Qaabaynta Cookies-ka",
              barBtnAcceptAll: "Aqbal dhammaan cookies-ka",
              modalMainTitle: "Qaabaynta Cookies-ka",
              modalMainText:
              "Cookie waa macluumaad kombuyuutar oo laga soo diro borogaraamka bogga internetka lagu furo waxaana lagu keydiyaa borogaraamka bogga internetka lagu furo ee qofku isticmaalayo marka uu wax ka raadinayo. Borogaraamka boggaaga internetka lagu furo wuxuu farriin kasta ku keydinayaa fayl yar, oo loogu yeero Cookie. Markii aad bog kale ka furtid isla khadkaas wuxuu borogaraamka bogga internetka lagu furo mar kale u dirayaa Cookie khadka internetka. Cookies waxaa loo sameeyay qaab lagu kalsoon yahay oo bogagga internetka kusoo xasuusan karaan macluumaadka ama in lagu diiwaangeliyo dhaqdhaqaaqa isticmaalaha markii uu internetka isticmaalayo.",
              modalBtnSave: "Keydso qaabayntaada hadda",
              modalBtnAcceptAll: "Aqbal dhammaan cookies-ka oo xir",
              modalAffectedSolutions: "Xalalka ay qusayso:",
              learnMore: "Wax dheeraad ah oga",
              on: "Daarid",
              off: "Xirid (damin)",
              enabled: "waa la awooddaa.",
              disabled: "waa la joojiyaa.",
              checked: "la saxay",
              unchecked: "aan la saxaynay",
            },
            yi: {
              barMainText: "באַשטעטיקן אַלע קיכלעך און פֿאַרמאַכן",
              closeAriaLabel: "פארשליסן",
              barLinkSetting: "קיכלעך־אײַנשטעלונגען",
              barBtnAcceptAll: "באַשטעטיקן אַלע קיכלעך",
              modalMainTitle: "קיכלעך־אײַנשטעלונגען",
              modalMainText:
                'קיכלעך זענען קלײנע שטיקלעך דאַטאַ געשיקט פֿון אַ װעבזײַטל און אַראָפּגעלאָדן צום באַניצערס קאָמפּיוטער דורכן וועב־בלעטערער בעת דער באַניצער ניצט די אינטערנעץ. דער בלעטערער לאָדט אַראָפּ אַלע מעלדונגען אין אַ קלײנער טעקע, דאָס הײסט אַ "קיכל". ווען דו פֿאָדערסט אַן אַנדער זײַטל פֿונעם סערווער שיקט דער בלעטערער דאָס קיכל צוריק צום סערווער. מע האָט געשאַפֿט קיכלעך כּדי צו זײַן אַ געטרוילעכער מעכאַניזם פֿאַר וועבזײַטלעך כּדי צו געדענקען אינפֿאָרמאַציע אָדער רעגיסטרירן אַ באַניצערס אינטערנעץ־אַקטיוויטעט.',
              modalBtnSave: "שפּאָרן די אַקטועלע אײַנשטעלונגען",
              modalBtnAcceptAll: "באַשטעטיקן אַלע קיכלעך און פֿאַרמאַכן",
              modalAffectedSolutions: "באַווירקטע לייזונגען",
              learnMore: "מער דאַרף איך וויסן",
              on: "אָן",
              off: "אויף",
              enabled: "איז ענאַבלעט.",
              disabled: "איז דיסעבלעד.",
              checked: "אַווערקענט",
              unchecked: "אָנקעקט",
            },
            mea: {
              barMainText: "Tämä vebbipaikka käyttää kuukkiksia ette varmistaa ette sie saat parhaiman kokemuksen meän vebbipaikalta.",
              closeAriaLabel: "sulje",
              barLinkSetting: "Kuukki-tälläyksiä (Cookie)",
              barBtnAcceptAll: "Hyväksy kaikki kuukkikset",
              modalMainTitle: "Kuukki-tälläyksiä (Cookie)",
              modalMainText:
                "Kuukkikset on pienet tietopalaset joita lähätethään yhestä vebbipaikasta ja säilytethään käyttäjän daatturissa käyttäjän vebbilukijalta kun käyttäjä syrffaa. Sinun vebbilukija säilyttää joka lähätyksen pienissä fiilissä, kuttuttu kuukki. Kun sie tahot muun sivun serveriltä sinun vebbilukija lähättää kuukkin takashiin serverhiin. Kuukkikset loithiin siksi ette saa luotettavan mekanismin vebbipaikoile, joka muistaa tietoja eli ette rejistreerata käyttäjän syrffitoimintaa.",
              modalBtnSave: "Säästä nykyhetken tälläykset",
              modalBtnAcceptAll: "Hyväksy kaikki kuukkikset ja pane kiini",
              modalAffectedSolutions: "Vaikuttunheet ratkaisut:",
              learnMore: "Lisää tietoa",
              on: "Päälä",
              off: "Poiessa",
              enabled: "on käytössä.",
              disabled: "on poissa käytöstä.",
              checked: "valittu",
              unchecked: "valitsematon",
            },
            sam: {
              barMainText: "Dát neahttabáiki geavaha diehtočoahkuid vai sihkkarastá, ahte oaččut buoremus vásáhusa min neahttabáikkis.",
              closeAriaLabel: "lohku",
              barLinkSetting: "Diehtočoahkku-ásahusat",
              barBtnAcceptAll: "Dohkket buot diehtočoahkuid",
              modalMainTitle: "Diehtočoahkku-ásahusat",
              modalMainText:
                "Diehtočoahkut leat smávva diehtobihtát mat sáddejuvvojit neahttabáikkis ja maid geavaheaddji neahttalogan vurke geavaheaddji dihtorii, go geavaheaddji bláđe. Du neahttalogan vurke juohke dieđu smávva fiilii mii gohčoduvvo diehtočoahkkun. Go bivddát eará siiddu serveris, du neahttalogan sádde diehtočoahku ruovttoluotta serverii. Diehtočoahkut leat plánejuvvon leat luohtehahtti mekanisman mainna neahttabáikkit muitet dieđuid dahje vurkejit geavaheaddji bláđenaktivitehta.",
              modalBtnSave: "Vurke dálá ásahusaid",
              modalBtnAcceptAll: "Dohkket buot diehtočoahkuid ja govčča",
              modalAffectedSolutions: "Ovddidit háláit:",
              learnMore: "Ollu deaivvadit",
              on: "Alde",
              off: "Eret",
              enabled: "leat válddán.",
              disabled: "leat válddejuvvon.",
              checked: "čeahppá",
              unchecked: "čeahppájuvvon",
            },
          },
        },
        // List all the categories you want to display.
        categories: {
          necessary: {
            needed: true,
            // The cookies in this category will be let trough.
            // This probably should be false if category not necessary.
            wanted: true,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: "Nödvändiga",
                  description:
                    "Nödvändiga cookies hjälper dig att göra en hemsida användbar, genom att aktivera grundläggande funktioner såsom sidnavigering åtkomst till säkra områden på hemsidan. Hemsidan kan inte fungera optimalt utan dessa cookies.",
                },
                en: {
                  name: "Necessary",
                  description:
                    "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
                },
                ar: {
                  name: "ضرورية",
                  description:
                  "تساعدك ملفات تعريف الارتباط الضرورية على جعل موقع الويب جاهزا للاستخدام وذلك من خلال إتاحة الوظائف الأساسية مثل ضمان التنقل عبر الصفحة إلى المناطق الآمنة في موقع الويب. لا يمكن لموقع الويب أن يعمل على النحو الأمثل بدون ملفات تعريف الارتباط هذه.",
                },
                fi: {
                  name: "Välttämättömät",
                  description:
                  "Välttämättömät evästeet auttavat tekemään verkkosivustosta käyttökelpoisen siten, että ne aktivoivat perustoiminnot, kuten sivuilla navigoinnin ja pääsyn verkkosivuston suojatuille alueille. Ilman näitä evästeitä sivusto ei toimisi parhaalla mahdollisella tavalla.",
                },
                fa: {
                  name: "ضروری",
                  description:
                  "کوکی",
                },
                ro: {
                  name: "Necesare",
                  description:
                  "Cookie-urile necesare vă ajută să faceți un site web util, prin activarea funcțiilor de bază, cum ar fi accesul navigării la zonele sigure ale site-ului. Site-ul web nu poate funcționa optim fără aceste cookie-uri.",
                },
                so: {
                  name: "Laga ma maarmaan",
                  description:
                  "Cookies-ka laga ma maarmaanka ah waxay kugu caawinayaan inaad samaysid bog internet adeeg wanaagsan, adigoo hawlgelinaya waxyaalaha uu ku shaqeeyo ee aasaasiga ah sida bogga sida lagu helayo, iyo soo gelitaanka meelaha amniga ah ee bogga internetka. Bogga internetka si fiican uma shaqayn karo Cookies la´aantood.",
                },
                yi: {
                  name: "נײטיקע",
                  description:
                    "נײטיקע קיכלעך העלפֿן צו מיטן מאַכן אַ װעבזײַטל ניצלעך דורכן אַקטיווירן גרונטיקע פֿונקציעס װי למשל זײַט־נאַוויגאַציע, צוטריט צו זיכערע ערטער אינעם װעבזײַטל. דאָס װעבזײַטל אַרבעט ניט גוט אָן די דאָזיקע קיכלעך.",
                },
                mea: {
                  name: "Tarpheeliset",
                  description:
                    "Tarpheeliset kuukkikset auttavat sinua tekemhään kotisivun käytettäväks, aktiveeramalla perusfynksjuunia kuten sivuplaavauksen käytettävyys varmhoin kotisivun alueishiin. Kotisivu ei saata toimia täyvelisesti ilman näitä kuukkiksia.",
                },
                sam: {
                  name: "Vealtameahttumat",
                  description:
                    "Vealtameahttun diehtočoahkut veahkehit dahkat neahttabáikkis anolačča nu, ahte suvvet vuođđodoaimmaid dego siidonavigerema beassama neahttabáikki suddjejuvvon guovlluide. Neahttabáiki ii doaimma buoremus lági mielde almmá dáid diehtočoahkuid haga.",
                },
              },
            },
          },
          statistic: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: "Statistiska",
                  description:
                    "Statistiska cookies hjälper hemsidans ägare att förstå hur besökare interagerar med hemsidan, genom att samla in och rapportera uppgifter.",
                },
                en: {
                  name: "Statistical",
                  description:
                  "Statistical cookies help website owners understand how visitors interact with the website by collecting and reporting data.",
                },
                ar: {
                  name: "احصائية",
                  description:
                  "إن ملفات تعريف الارتباط الاحصائية تساعد مالك موقع الإنترنت على فهم مدى اندماج المستخدم مع موقع الإنترنت عن طريق تجميع البيانات والتبليغ عنها.",
                },
                fi: {
                  name: "Tilastolliset",
                  description:
                  "Tilastolliset evästeet auttavat sivuston omistajaa ymmärtämään kävijöiden ja verkkosivujen välistä vuorovaikutusta keräämällä ja raportoimalla tietoja.",
                },
                fa: {
                  name: "کوکی",
                  description:
                  "کوکی",
                },
                ro: {
                  name: "Solutii afectate:",
                  description:
                  "Cookie-urile statistice ajută proprietarul site-ului web să înțeleagă modul în care vizitatorii interacționează cu site-ul web, prin colectarea și raportarea datelor.",
                },
                so: {
                  name: "Tiro koob (istatistiko)",
                  description:
                  "Cookies-ka tirokoobka (istatistikada) loogu talo galay waxay mulkiilaha bogga internetka ku caawinayaan inuu fahmo sida dadka bogga soo booqanaya ula falgalayaan, isagoo ka uruurinaya oo ka gudbinaya xog.",
                },
                yi: {
                  name: "סטאַטישע",
                  description:
                    "סטאַטישע קיכלעך העלפֿן דעם פֿאַרמאָגער פֿון אַ וועבזײַטל צו פֿאַרשטײן די אינטעראַקציע צווישן באַזוכערס און דעם דאָזיקן װעבזײַטל, דורכן צונויפֿזאַמלען און ראַפּאָרטירן אינפֿאָרמאַציע.",
                },
                mea: {
                  name: "Statistiset",
                  description:
                    "Statistiset kuukkikset auttavat kotisivun omistajaa ymmärthään kuinka kävijät vaikuttavat ja osalistuvat molemphiin suunthiin kotisivun kans, kerräämällä ja ilmottamalla tietoja.",
                },
                sam: {
                  name: "Statistihkalaš",
                  description:
                    "Statistihkalaš diehtočoahkut veahkehit neahttabáikki oamasteaddji áddet mo galledeaddjit leat vuorrováikkuhusas neahttabáikkiin dieđuid čoaggimiin ja raporteremiin.",
                },
              },
            },
          },
          marketing: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: "Marknadsföring",
                  description:
                    "Marketingcookies används för att spåra besökare gränsöverskridande på hemsidor. Avsikten är att visa annonser som är relevanta och engagerande för den enskilda användaren och därmed vara mer värdefulla för utgivare och tredjepartsannonsörer.",
                },
                en: {
                  name: "Marketing",
                  description:
                  "Marketing cookies are used to track visitors across websites. The purpose is to display ads that are relevant and engaging to the individual user and thus more valuable to publishers and third-party advertisers.",
                },
                ar: {
                  name: "تسويق",
                  description:
                  "تستخدم ملفات تعريف الارتباط التسويقية لتتبع الزوار عبر الحدود على مواقع الويب. إن الهدف الكامن من وراء ذلك هو عرض إعلانات ذات صلة وجذابة بالنسبة للمستخدم الفردي، وبالتالي تكون أكثر قيمة للناشرين والمعلنين من الطرف الثالث.",
                },
                fi: {
                  name: "Markkinointi",
                  description:
                  "Markkinointievästeitä käytetään kävijöiden jäljittämiseksi verkkosivuilla yli rajojen. Tarkoituksena on näyttää mainoksia, jotka ovat käyttäjän kannalta osuvia ja kiinnostavia ja näin ollen merkityksellisempiä sekä niiden julkaisijalle että myös kolmannen osapuolen mainonnalle.",
                },
                fa: {
                  name: "کوکی",
                  description:
                  "کوکی",
                },
                ro: {
                  name: "Marketing",
                  description:
                  "Cookie-urile de marketing sunt folosite pentru a urmări vizitatorii transfrontalier pe site-uri web. Intenția este de a afișa reclame relevante și captivante pentru utilizatorul individual și, astfel, să fie mai valoroase pentru editori și agenții de publicitate terțe.",
                },
                so: {
                  name: "Suuq geyn",
                  description:
                  '"Marketingcookies" waxaa loo isticmaalaa si loo ogaado dadka booqanaya oo iskaga kala gooshaya bogagga internetka kala duwan. Ujeedadu waa in xayaysiin ku haboon oo ihtimaam leh la tuso qofka shaqsiga ah ee isticmaalaya, sidaas darteed bay qiimo ugu fadhiyaan soo saarayaasha iyo kuwa wax ku xayaysiiya gacan saddexaad.',
                },
                yi: {
                  name: "רעקלאַמע",
                  description:
                    'מע ניצט "מאַרקעטינג"־קיכלעך כּדי צו נאָכשפּירן נאָך באַזוכערס איבער פֿאַרשײדענע װעבזײַטלעך. דער ציל איז צו פֿאָרשטעלן באַטײַטיקע אַנאָנסן פֿאַרן באַניצער און דערמיט אויך צו זײַן הצלחהדיק פֿאַרן אַרויסגעבער און דעם אַנאָנסירער.',
                },
                mea: {
                  name: "Markkinointi",
                  description: "Markkinointi kuukkiksia käytethään ette jäljittää kotisivun rajaylimeneviä kävijöitä. Tarkotus on ette näyttää relevantila ja kiinostavila anonsila yksityisele käyttäjäle ja sillä tavala olla enemän arvokhaamat anonsin omistajale ja kolmaspuolen anonsöörile.",
                },
                sam: {
                  name: "Márkanfievrrideapmi",
                  description: "Márkanfievrridandiehtočoahkut geavahuvvojit gallededdjiid čuovvumii rájáid rasttildan neahttabáikkiin. Ulbmilin lea čájehit reklámaid, mat leat relevánttat ja miellagiddevaččat ovttaskas geavaheaddji geažil ja nu leat mávssolaččabut olggosaddiide ja goalmmát oassebeali reklamerejeddjiide.",
                },
              },
            },
          },
        },
        // List actual services here.
        services: {
          // Unique name.
          analytics: {
            // Existing category Unique name.
            // This example shows how to block Google Analytics.
            category: "statistic",
            // Type of blocking to apply here.
            // This depends on the type of script we are trying to block.
            // Can be: dynamic-script, script-tag, wrapped, localcookie.
            type: "dynamic-script",
            // Only needed if "type: dynamic-script".
            // The filter will look for this keyword in inserted scipt tags
            //  and block if match found.
            search: "analytics",
            // List of known cookie names or regular expressions matching
            //  cookie names placed by this service.
            // These will be removed from current domain and .domain.
            cookies: [
              {
                // Known cookie name.
                name: "_gid",
                // Expected cookie domain.
                domain: `.${window.location.hostname}`,
              },
              {
                // Regex matching cookie name.
                name: /^_ga/,
                domain: `.${window.location.hostname}`,
              },
            ],
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: "Google Analytics",
                },
                en: {
                  name: "Google Analytics",
                },
                ar: {
                  name: "تحليلات قوقل",
                },
                fi: {
                  name: "Google Analytics",
                },
                fa: {
                  name: "تجزیه و تحلیل",
                },
                ro: {
                  name: "Google Analytics",
                },
                so: {
                  name: "Google Analytics",
                },
                yi: {
                  name: "גוגל אַנאַליטיקס",
                },
                mea: {
                  name: "Google Analytics",
                },
                sam: {
                  name: "Google Analytics",
                },
              },
            },
          },
        },
        consentModeControls: {
          ad_storage: "marketing",
          ad_user_data: "marketing",
          ad_personalization: "marketing",
          analytics_storage: "statistic",
        },
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./src/scripts/routes/common.js